import { useTranslation } from 'react-i18next'
import { InformationCircleIcon } from '@heroicons/react/24/outline'

/** VH-224: names a metric the data source never records instead of an empty chart. */
export default function UnrecordedMetricNote({ metricKey }) {
  const { t } = useTranslation()
  return (
    <div className="bg-surface-container border rounded-lg p-4 flex items-start gap-2" data-testid={`unrecorded-${metricKey}`}>
      <InformationCircleIcon className="h-5 w-5 text-gray-500 shrink-0" />
      <p className="text-sm text-gray-600">
        {t('sleepRecovery.unrecorded', { metric: t(`sleepRecovery.metrics.${metricKey}`) })}
      </p>
    </div>
  )
}
